<button
  (click)="handleMoreClick()"
  class="link">
  <ng-content />
</button>

<app-menu-item-more-content
  [@openClose]="expanded ? 'open' : 'close'"
  [contentTemplateRef]="contentTemplateRef"
  [item]="item" />
